export const MONTH_MAP: { [key: string]: string } = {
  January: '01',
  February: '02',
  March: '03',
  April: '04',
  May: '05',
  June: '06',
  July: '07',
  August: '08',
  September: '09',
  October: '10',
  November: '11',
  December: '12',
};

export const ONBOARDING_STEP_KEY = 'onboarding_current_step';

export const ACCEPTANCE_WARNING_LS_KEY = 'acceptanceWarning:hide';
export const TOUR_LS_KEY = 'tour:hide';
export const UNDER_REVIEW_LS_KEY = 'underReview:hide';
